import { createAsyncThunk, createSlice, createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { getCompanyInterviewBuilderData, GraphQL } from '../../utils/api';
import { createValue as gqlCreateValue} from '../../graphql/mutations';
import { weightedAverage } from '../../features/summary/chart/weightedAverage';

const initialState: any = {
  data: {
    questions: [],
    weightedValues: []
  },
  status: 'idle',
  questions: [],
};

export const fetchInterviewBuilder = createAsyncThunk(
  'company/fetchInterviewBuilder', async (compId: string) => {            
    await getCompanyInterviewBuilderData(compId).then((response) => {
      // JSON.parse(interviewBuilderData)
      const parsedBuilder = JSON.parse(response?.interviewBuilderData)
      return parsedBuilder || {}
    })
  }
);

export const createInterviewBuilder = createAsyncThunk(
  'company/createInterviewBuilder', async (_variables: any) => {
  }
);


export const updateInterviewBuilder = createAsyncThunk(
  'company/updateeInterviewBuilder', async (_variables: any) => {
  }
);

const insertUniqueQuestions = (state: any, questions: any) => {
  const existingQuestions = state.questions || [];
  const newQuestions = questions || [];

  const uniqueQuestions = Array.from(new Set([...existingQuestions, ...newQuestions]));

  return uniqueQuestions;
}

export const interviewBuilderSlice = createSlice({
  name: 'interviewBuilder',
  initialState,
  reducers: {
    insertQuestions: (state: any, { payload }: any) => {
      const questions = insertUniqueQuestions(state.questions, payload);
      state.questions = questions;
    },
    deleteQuestions: (state: any, { payload }: any) => {
      const filteredQuestions = state.questions.filter((item: any) => !payload.includes(item.id));
      state.questions = filteredQuestions;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInterviewBuilder.pending, (state: any) => {
        state.status = 'loading';
      })
      .addCase(fetchInterviewBuilder.fulfilled, (state: any, { payload }: any) => {
        state.status = 'idle';
        state.data = payload;
      })
      .addCase(fetchInterviewBuilder.rejected, (state: any, { payload }: any) => {
        state.status = 'failed';
        console.error('Fetching interview builder data failed.', payload)
      })
      .addCase(createInterviewBuilder.pending, (state: any) => {
        state.status = 'loading';
      })
      .addCase(createInterviewBuilder.fulfilled, (state: any) => {
        state.status = 'idle';
      })
      .addCase(createInterviewBuilder.rejected, (state: any, { payload }: any) => {
        state.status = 'failed';
        console.error('creating interview builder data failed.', payload)
      })
      .addCase(updateInterviewBuilder.pending, (state: any) => {
        state.status = 'loading';
      })
      .addCase(updateInterviewBuilder.fulfilled, (state: any) => {
        state.status = 'idle';
      })
      .addCase(updateInterviewBuilder.rejected, (state: any, { payload }: any) => {
        state.status = 'failed';
        console.error('updating interview builder data failed.', payload)
      });
  },
});

export const { insertQuestions, deleteQuestions } = interviewBuilderSlice.actions;

export const selectedWeightedValues = (
  state: RootState
) => {
  return state?.interviewBuilder?.data?.weightedValues;
};

export const selectMemoWeightedValues = createSelector(
  selectedWeightedValues,
  (selectedWeightedValues) => selectedWeightedValues
);

export const selectValueById = createSelector(
  [selectMemoWeightedValues, (_state, id) => id],
  (items, id) =>
    items?.find((value: any) => {
      return value.id === id;
    })
);

export const selectQuestions = (
  state: RootState
) => {
  return state?.interviewBuilder?.questions;
};

export default interviewBuilderSlice.reducer;
